module.exports = __webpack_public_path__ + "static/media/plusIcon.dd02b7c4.svg";